import { Tag, DefinitionTooltip } from '@carbon/react';
import type { ExplorationPopulateStatus } from '@snxt/snxt-onto-share';

interface ExplorationStatusProps {
  status: ExplorationPopulateStatus;
  /** Failure reason (populate_error). Surfaced on hover when status is failed. */
  error?: string | null;
}

const tagType = (s: ExplorationPopulateStatus): 'green' | 'red' | 'blue' | 'gray' =>
  s === 'completed' ? 'green' : s === 'failed' ? 'red' : s === 'running' ? 'blue' : 'gray';

/**
 * ExplorationStatus — the populate status of a Knowledge Graph, with the
 * failure REASON surfaced on hover (Feedback A5). When a populate run fails the
 * backend stores populate_error; without this the UI only showed a bare
 * "failed" tag and users could not tell whether it was their fault or the
 * platform's. Mirrors the failed-document tooltip on the Knowledge Base page.
 */
export const ExplorationStatus = ({ status, error }: ExplorationStatusProps) => {
  const tag = (
    <Tag size="sm" type={tagType(status)} data-testid="exploration-status">
      {status}
    </Tag>
  );

  if (status === 'failed' && error) {
    return (
      <DefinitionTooltip openOnHover align="bottom" definition={error}>
        <span data-testid="exploration-status-failed">{tag}</span>
      </DefinitionTooltip>
    );
  }

  return tag;
};
